<template>
  <div class="profile-container">
    <LandingBar active="portfolio" />
    <div class="profile-wrapper">
      <v-breadcrumbs :items="bread" divider=">"></v-breadcrumbs>
      <h3 class="table-headline">Profile</h3>
      <!-- <div class="profile-row">
        <strong>Username: </strong>
        <div class="profile-name">{{ currentUser.username }}</div>
      </div>
      <div class="profile-row">
        <strong>Token: </strong>
        <div class="profile-name">
          {{ currentUser.accessToken.substring(0, 20) }} ...
          {{
            currentUser.accessToken.substr(currentUser.accessToken.length - 20)
          }}
        </div>
      </div>
      <div class="profile-row">
        <strong>Id: </strong>
        <div class="profile-name">{{ currentUser.id }}</div>
      </div> -->
      <!-- <div class="profile-row">
        <strong>Email: </strong>
        <div class="profile-name">{{ currentUser.email }}</div>
      </div>
      <div class="profile-row">
        <strong>Company Code: </strong>
        <div class="profile-name">{{ currentUser.companyCode }}</div>
      </div>
      <div class="profile-row">
        <strong>Authorities: </strong>
        <ul>
          <li v-for="(role, index) in currentUser.roles" :key="index">
            {{ role }}
          </li>
        </ul>
      </div> -->
      <div class="profile-inner-wrapper">
        <div class="profile-image-wrapper">
          <img
            src="../img/logo-color.png"
            class="placeholder-image"
            alt="placeholder"
          />
          <div class="profile-edit">Update logo</div>
        </div>
        <div class="form-group">
          <div class="form-flex">
            <div class="column2">
              <label for="companyName">Company Name</label>
              <input
                v-model="user.companyName"
                type="text"
                name="companyName"
                disabled
                placeholder="Enter your company name."
                class="bottom-margin2"
              />
              <div
                v-if="errors.has('companyName')"
                class="alert alert-danger"
                role="alert"
              >
                Company Name is required!
              </div>
            </div>
            <div class="column2">
              <label for="companyType">Company Type</label>
              <select
                v-model="user.roles[0].name"
                name="companyType"
                disabled
                class="bottom-margin2"
                id="companyType"
              >
                <option value="companyType" disabled>
                  Choose your company type
                </option>
                <option value="ROLE_TSO">TSO</option>
                <option value="ROLE_DSO">DSO</option>
                <option value="ROLE_FSP">FSP</option>
                <option value="ROLE_USER">User</option>
              </select>
              <div
                v-if="errors.has('companyType')"
                class="alert alert-danger"
                role="alert"
              >
                <font color="#a41517">Company Type is required!</font>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="form-group">
          <div class="form-flex">
            <div class="column2">
              <label for="email">Email</label>
              <input
                v-model="user.email"
                disabled
                v-validate="'required|email|max:50'"
                type="email"
                class="bottom-margin2"
                name="email"
                placeholder="Enter your email."
              />
              <div
                v-if="errors.has('email')"
                class="alert alert-danger"
                role="alert"
              >
                <font color="#a41517">Email is required!</font>
              </div>
              <div v-if="submitted && errors.has('email')" class="alert-danger">
                {{ errors.first("email") }}
              </div>
            </div>
            <div class="column2">
              <label for="password">Password</label>
              <input
                v-model="user.password"
                disabled
                v-validate="'required|min:8|max:40'"
                type="password"
                class="bottom-margin2"
                name="password"
                placeholder="Enter your password, at least 8 characters."
              />
              <div
                v-if="errors.has('password')"
                class="alert alert-danger"
                role="alert"
              >
                <font color="#a41517">Password is required!</font>
              </div>
              <div
                v-if="submitted && errors.has('password')"
                class="alert-danger"
              >
                {{ errors.first("password") }}
              </div>
            </div>
          </div>
        </div> -->

        <div class="form-group">
          <input
            hidden
            v-model="user.companyCode"
            value="companyCode"
            type="text"
            name="companyCode"
            class="bottom-margin2"
          />
        </div>
        <div class="form-group">
          <div class="form-flex">
            <div class="column2">
              <label for="companyAddress">Street Name</label>
              <input
                v-model="user.companyAddress"
                type="text"
                name="address"
                placeholder="Enter your street name."
                class="bottom-margin2"
              />
              <div
                v-if="errors.has('companyAddress')"
                class="alert alert-danger"
                role="alert"
              >
                Street Name is required!
              </div>
            </div>
            <div class="column2">
              <label for="buildingNumber">Number</label>
              <input
                v-model="user.buildingNumber"
                type="text"
                name="buildingNumber"
                placeholder="Enter your building number."
                class="bottom-margin2"
              />
              <div
                v-if="errors.has('buildingNumber')"
                class="alert alert-danger"
                role="alert"
              >
                Street Name is required!
              </div>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="form-flex">
            <div class="column2">
              <label for="city">City</label>
              <input
                v-model="user.city"
                type="text"
                name="city"
                placeholder="Enter your city name."
                class="bottom-margin2"
                id="city"
              />
              <div
                v-if="errors.has('city')"
                class="alert alert-danger"
                role="alert"
              >
                City Name is required!
              </div>
            </div>
            <div class="column2">
              <label for="postalCode">Postal Code</label>
              <input
                v-model="user.postcode"
                type="text"
                name="postalCode"
                placeholder="Enter your postal code."
                class="bottom-margin2"
              />
              <div
                v-if="errors.has('postcode')"
                class="alert alert-danger"
                role="alert"
              >
                Postcode is required!
              </div>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="form-flex">
            <div class="column2">
              <label for="phoneNumber">Phone Number</label>
              <input
                v-model="user.phoneNumber"
                type="text"
                name="phoneNumber"
                placeholder="Enter your phone number."
                class="bottom-margin2"
              />
              <div
                v-if="errors.has('phoneNumber')"
                class="alert alert-danger"
                role="alert"
              >
                Phone Number is required!
              </div>
            </div>
            <div class="column2">
              <label for="country">Country</label>
              <select v-model="user.countryCode" class="bottom-margin2" disabled>
                <option value="AT" label="Austria">Austria</option>
                <option value="BE" label="Belgium">Belgium</option>
                <option value="BG" label="Bulgaria">Bulgaria</option>
                <option value="HR" label="Croatia">Croatia</option>
                <option value="FR" label="France">France</option>
                <option value="DE" label="Germany">Germany</option>
                <option value="GR" label="Greece">Greece</option>
                <option value="HU" label="Hungary">Hungary</option>
                <option value="IT" label="Italy">Italy</option>
                <option value="LU" label="Luxembourg">Luxembourg</option>
                <option value="NL" label="Netherlands">Netherlands</option>
                <option value="PL" label="Poland">Poland</option>
                <option value="PT" label="Portugal">Portugal</option>
                <option value="RO" label="Romania">Romania</option>
                <option value="SE" label="Sweden">Sweden</option>

                <option
                  v-for="country in countries"
                  :value="country"
                  v-bind:key="country"
                >
                  {{ country.countryName }}
                </option>
              </select>
              <div
                v-if="errors.has('country')"
                class="alert alert-danger"
                role="alert"
              >
                Country is required!
              </div>
            </div>
          </div>
        </div>
        <div class="profile-confirmed-wrapper">
          <div v-if="confirmed" class="confirmed-text">
            Profile has been successfully saved
          </div>
        </div>
        <div class="signin-modal-bottom profile-button">
          <v-btn
            elevation="2"
            color="#59c26b"
            :loading="loading"
            :disabled="loading"
            class="transfer-button"
            v-on:click="updateProfile"
          >
            Update</v-btn
          >
        </div>
      </div>
      <!-- <div class="already-wrapper">
          <br>
      </div>
      <div class="already-wrapper">
          <button class="signin-modal-bottom"><a href="/changePassword">Change your password</a></button>
      </div>  -->
    </div>
  </div>
</template>

<script>
import User from "../models/user";
import LandingBar from "../components/Common/LandingBarAdmin.vue";

export default {
  name: "Profile",

  components: {
    LandingBar,
  },

  data() {
    return {
      user: new User("", "", "", "", "", "", "", "", "", "", "", "", [
        { id: 1, name: "" },
      ]),
      loading: false,
      confirmed: false,
      submitted: false,
      message: "",
      countries: ["Belgium"],
      bread: [
        {
          text: "Portfolio Management",
          disabled: false,
        },
        {
          text: "Profile",
          disabled: false,
        },
      ],
    };
  },

  methods: {
    updateProfile() {
      this.loading = true;
      this.submitted = true;
      this.$store.dispatch("auth/profile", this.user).then(
        (data) => {
          this.loading = false;
          this.submitted = false;
          this.confirmed = true;
        },
        (error) => {
          console.log("Error:", error.response);
        }
      );
    },
  },

  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },

    showUserProfile() {
      if (this.currentUser) {
        return this.currentUser;
      }

      return false;
    },
  },
  mounted() {
    this.user = this.$store.state.auth.user;
    console.log("USER", this.user);
  },
};
</script>
<style lang="scss">
@import "../sass/main.scss";

.profile-container {
  background: #f8fcff;

  margin-top: -100px !important;
  min-height: 100vh;
}

.profile-wrapper {
  padding: 20px;
  margin: 0 40px;
}

.profile-row {
  display: flex;
  margin-bottom: 20px;
}

.profile-name {
  margin-left: 10px;
}

.signin-modal-bottom label {
  display: block;
  font-size: 0.9em;
  margin: 0 0 3px 5px;
}

.signin-modal-bottom input {
  width: 94%;
  padding: 10px 15px;
  border-radius: 10px;
  border: 1px solid #ccc;
}

.signin-modal-bottom a {
  margin-top: 5px;
  margin-left: 5px;
  font-size: 0.75em;
  display: inline-block;
}

.signin-modal-bottom button {
  width: 100%;
  padding: 10px 15px;
  border-radius: 10px;
  border: none;
  background: $green2;
  color: #fff;
}

.signin-modal-bottom button:hover {
  background: hsl(144, 58%, 40%);
}

.already-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  //aligin-items: center;
}

.column2 {
  width: 48%;
}

.profile-container label {
  display: block;
  font-size: 0.9em;
  margin: 0 0 3px 5px;
  color: #979797;
}

.profile-container input,
.profile-container select {
  width: 100%;
  padding: 12px 10px !important;
  border-radius: 3px;
  border: 1px solid #ccc;
  background: #fff;
}

.profile-inner-wrapper {
  max-width: 1000px;
  margin: 0 auto;
}

.profile-button {
  margin: 0 auto;
}

.profile-image-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
}

.placeholder-image {
  width: 120px;
}

.profile-edit {
  cursor: pointer;
  color: #59c26b;
  font-size: 18px;
  font-weight: 700;
  text-decoration: underline;
  margin-top: 20px;
}

.transfer-button {
  margin-bottom: 35px;
  margin-left: auto;
}

.transfer-button span {
  color: #fff;
  text-transform: none;
}

.profile-confirmed-wrapper {
  position: relative;
  width: 100%;
  padding: 20px 0;
}

.confirmed-text {
  position: absolute;
  top: 0;
  left: 0;
  color: #59c26b;
  font-weight: 600;
}
</style>